module.exports = __webpack_public_path__ + "static/media/city2.d8466de5.jpg";